$(function () {

  //Open External Links in new tab
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  //Hover On Menu
  // let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  // items.forEach(item => {
  //   item.addEventListener("mouseover", () => {
  //     item.setAttribute("open", true);
  //     item.querySelector("ul").addEventListener("mouseleave", () => {
  //       item.removeAttribute("open");
  //     });
  //     item.addEventListener("mouseleave", () => {
  //       item.removeAttribute("open");
  //     });
  //   });

  // });

  // Slick Slider
  $('body.template-index .section-collection-list .collection-list, body.template-index .featcoll ul.product-grid, body.template-index .mltcol ul.multicolumn-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 750,
        settings: 'unslick'
      }
    ]
  });

  $('body#resources .mltcol ul.multicolumn-list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
        {
        breakpoint: 1200,
        settings: {
            slidesToShow: 4,
        }
        },
        {
        breakpoint: 991,
        settings: {
            slidesToShow: 3,
        }
        },
        {
        breakpoint: 750,
        settings: "unslick"
        }
    ]
  });

  // Unslick for a specific element
  $('body.template-index #shopify-section-template--16550379946183__multicolumn_6hFKMw.mltcol ul.multicolumn-list, body.template-index #shopify-section-template--16550379946183__4df635ce-8b79-4900-8144-9cb6f6780ea0.mltcol ul.multicolumn-list').slick('unslick');

    // Alternatively, if you want to modify the default buttons after Slick initializes
  $('.slick-prev').attr('role', 'button').attr('aria-label', 'Previous');
  $('.slick-next').attr('role', 'button').attr('aria-label', 'Next');
});